import { Source, Statistics } from "../../@types/common";
import NetworkThreatNoDataMsg from "../common/NetworkThreatNoDataMsg";
import ThirdPartyReputationList from "./lists/ThirdPartyReputationList";
import NetworkThreatCard from "./NetworkThreatCard";

import Typography from "../../../../components/typography/Typography";
import { sortThirdPartyReputationsFn } from "../../../utils/sort";

type Props = {
  reputations: Source[];
  statistics?: Statistics;
};

const ReputationsCard = ({ reputations, statistics }: Props) => {
  const sorted = (reputations || []).sort(sortThirdPartyReputationsFn);
  return (
    <NetworkThreatCard
      width="full"
      errorComp={
        <NetworkThreatCard.Error>
          <NetworkThreatNoDataMsg />
        </NetworkThreatCard.Error>
      }
      header={
        <NetworkThreatCard.Header
          title={
            <div className="flex align-center gap-10">
              <Typography variant="h3">Third Party Reputation</Typography> |{" "}
              <div className="flex align-center gap-10 text-normal">
                <div>
                  <b>Total: </b> {statistics?.total ?? "--"}
                </div>
                <div>
                  <b className="network-threat-intelligence__malicious-count">
                    Malicious:{" "}
                  </b>{" "}
                  {statistics?.malicious ?? "--"}
                </div>
                <div>
                  <b className="network-threat-intelligence__suspicious-count">
                    Suspicious:{" "}
                  </b>{" "}
                  {statistics?.suspicious ?? "--"}
                </div>
                <div>
                  <b className="network-threat-intelligence__goodware-count">
                    Clean:{" "}
                  </b>{" "}
                  {statistics?.clean ?? "--"}
                </div>
                <div>
                  <b>Undetected: </b> {statistics?.undetected ?? "--"}
                </div>
              </div>
            </div>
          }
        />
      }
      contentClassName="p-0"
      content={
        <div className="flex flex-center justify-content-center">
          <ThirdPartyReputationList sources={sorted || []} />
        </div>
      }
    />
  );
};

export default ReputationsCard;
